// src/config/config.js

const config = {
  // Endpoints
  URLS: {
    HOST: 'https://gerencialp.cloud',
    PATIENTS: '/api-gateway/gerencia/patient',
    ANAMNESIS: '/api-gateway/gerencia/anamnesis',
    GUARDIANS: '/api-gateway/gerencia/guardian',
    PUB: 'https://gerencialp.cloud',
  }
};

export default config;
